/* Royal Tails theme script.
   Bag drawer (Shopify AJAX cart API), variant pickers, quick add, card swatches, sorting. */
(function () {
  'use strict';

  var RT = window.RoyalTails || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, strings: {}, cartDrawer: true };
  var S = RT.strings || {};

  /* ---------- Helpers ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || RT.moneyFormat || '${{amount}}';
    function withDelimiters(n, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      var parts = (n / 100).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function sizedImage(src, width) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function swapImage(img, src, alt) {
    if (!img || !src) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.classList.add('is-swapping');
    var pre = new Image();
    pre.onload = pre.onerror = function () {
      img.src = src;
      if (alt != null) img.alt = alt;
      img.classList.remove('is-swapping');
    };
    pre.src = src;
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(handle);
  }

  function handle(res) {
    return res.json().then(function (data) {
      if (!res.ok) throw new Error(data.description || data.message || S.error);
      return data;
    });
  }

  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ---------- Bag drawer ---------- */
  var drawer, overlay, lastFocus;

  function setCount(n) {
    document.querySelectorAll('[data-bag-count]').forEach(function (el) { el.textContent = n; });
  }

  function renderCart(cart) {
    setCount(cart.item_count);
    if (!drawer) return;
    var body = drawer.querySelector('[data-bag-body]');
    var foot = drawer.querySelector('[data-bag-foot]');

    if (!cart.item_count) {
      body.innerHTML =
        '<div class="drawer__empty">' + iconBowl() +
        '<p>' + esc(S.bagEmpty) + '</p>' +
        '<a class="btn btn--ghost" href="' + esc(RT.routes.collections) + '/all">' + esc(S.startShopping) + '</a></div>';
      foot.hidden = true;
      return;
    }

    foot.hidden = false;
    body.innerHTML = cart.items.map(function (item, i) {
      var img = item.image ? '<img src="' + esc(sizedImage(item.image, 200)) + '" alt="" width="88" height="88" loading="lazy">' : '';
      var variant = item.product_has_only_default_variant ? '' : '<span class="small muted">' + esc(item.variant_title) + '</span>';
      return '<div class="line-item">' +
        '<a class="line-item__img" href="' + esc(item.url) + '">' + img + '</a>' +
        '<div class="line-item__info">' +
          '<div class="line-item__top"><span>' + esc(item.product_title) + '</span><span class="price">' + esc(formatMoney(item.final_line_price)) + '</span></div>' +
          variant +
          '<div class="line-item__ctrl">' +
            '<div class="qty qty--sm">' +
              '<button type="button" data-line="' + (i + 1) + '" data-qty="' + (item.quantity - 1) + '" aria-label="' + esc(S.decrease) + '">&minus;</button>' +
              '<span class="qty__val">' + item.quantity + '</span>' +
              '<button type="button" data-line="' + (i + 1) + '" data-qty="' + (item.quantity + 1) + '" aria-label="' + esc(S.increase) + '">+</button>' +
            '</div>' +
            '<button class="line-item__remove" type="button" data-line="' + (i + 1) + '" data-qty="0">' + esc(S.remove) + '</button>' +
          '</div>' +
        '</div></div>';
    }).join('');
    drawer.querySelector('[data-bag-total]').textContent = formatMoney(cart.total_price);
  }

  function iconBowl() {
    return '<svg class="icon icon--lg" viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 23h34c0 9-7.5 14-17 14S7 32 7 23z"/><path d="M13 23c0-4 4-6 7-4.5 2-3 7-3 9 0 3-1.5 6 .5 6 4.5"/></svg>';
  }

  function refreshCart() {
    return fetch(RT.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(handle).then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }

  function openBag() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    overlay.hidden = false;
    drawer.hidden = false;
    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      drawer.classList.add('is-open');
      var close = drawer.querySelector('[data-bag-close]');
      if (close) close.focus();
    });
    document.documentElement.style.overflow = 'hidden';
  }

  function closeBag() {
    if (!drawer) return;
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { overlay.hidden = true; drawer.hidden = true; }, 450);
    if (lastFocus) lastFocus.focus();
  }

  function afterAdd() {
    if (!RT.cartDrawer || !drawer) {
      window.location.href = RT.routes.cart;
      return;
    }
    refreshCart().then(openBag);
  }

  function initDrawer() {
    drawer = document.querySelector('[data-drawer]');
    overlay = document.querySelector('[data-overlay]');
    if (!drawer || !overlay) return;

    overlay.addEventListener('click', closeBag);
    drawer.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t) return;
      if (t.hasAttribute('data-bag-close')) return closeBag();
      if (t.hasAttribute('data-line')) {
        drawer.classList.add('is-loading');
        postJSON(RT.routes.cartChange + '.js', { line: +t.dataset.line, quantity: Math.max(0, +t.dataset.qty) })
          .then(renderCart)
          .catch(function (err) { toast(err.message); })
          .then(function () { drawer.classList.remove('is-loading'); });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeBag();
    });

    document.querySelectorAll('[data-bag-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (!RT.cartDrawer) return;
        e.preventDefault();
        refreshCart().then(openBag).catch(function () { window.location.href = RT.routes.cart; });
      });
    });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    var toggle = document.querySelector('.menu-toggle');
    var nav = document.getElementById('mobile-nav');
    if (toggle && nav) {
      var labelOpen = toggle.textContent;
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        toggle.textContent = open ? labelOpen : (S.close || 'Close');
        nav.hidden = open;
      });
    }
    if (header) {
      var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 4); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  /* ---------- Product cards ---------- */
  function initCards() {
    document.addEventListener('click', function (e) {
      var quick = e.target.closest('[data-quick-add]');
      if (quick) {
        e.preventDefault();
        quick.disabled = true;
        postJSON(RT.routes.cartAdd + '.js', { items: [{ id: +quick.dataset.quickAdd, quantity: 1 }] })
          .then(afterAdd)
          .catch(function (err) { toast(err.message); })
          .then(function () { quick.disabled = false; });
        return;
      }

      var sw = e.target.closest('[data-card-variant]');
      if (sw) {
        var card = sw.closest('.card');
        if (sw.dataset.image) swapImage(card.querySelector('.card__img'), sw.dataset.image);
        if (sw.dataset.url) card.querySelectorAll('.card__link').forEach(function (a) { a.href = sw.dataset.url; });
        var q = card.querySelector('[data-quick-add]');
        if (q) q.dataset.quickAdd = sw.dataset.cardVariant;
        card.querySelectorAll('[data-card-variant]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === sw)); });
      }
    });
  }

  /* ---------- Product forms (main product and featured product) ---------- */
  function initProduct(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    var form = root.querySelector('[data-product-form]');
    if (!jsonEl || !form) return;
    var product = JSON.parse(jsonEl.textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add]');
    var qtyInput = form.querySelector('[data-qty]');
    var errorEl = form.querySelector('[data-form-error]');
    var priceEl = root.querySelector('.buy__price [data-price]');
    var mainImg = root.querySelector('.main-image');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-option]'));
    var isMainProduct = !!root.querySelector('.gallery');

    function selectedOptions() {
      return groups.map(function (g) {
        var on = g.querySelector('[aria-checked="true"]');
        return on ? on.dataset.value : null;
      });
    }

    function findVariant(opts) {
      return product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }

    function markAvailability(opts) {
      groups.forEach(function (g, gi) {
        g.querySelectorAll('[data-value]').forEach(function (b) {
          var test = opts.slice();
          test[gi] = b.dataset.value;
          var v = findVariant(test);
          b.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    function showMedia(variant) {
      if (!variant || !variant.featured_media) return;
      var id = String(variant.featured_media.id);
      var thumb = root.querySelector('.thumb[data-media-id="' + id + '"]');
      if (thumb) return selectThumb(thumb);
      if (variant.featured_image) swapImage(mainImg, sizedImage(variant.featured_image.src, 1400), variant.featured_image.alt || product.title);
    }

    function selectThumb(thumb) {
      swapImage(mainImg, thumb.dataset.src, thumb.dataset.alt);
      root.querySelectorAll('.thumb').forEach(function (t) { t.setAttribute('aria-current', String(t === thumb)); });
    }

    function update() {
      var opts = selectedOptions();
      var v = findVariant(opts);
      groups.forEach(function (g, i) {
        var label = g.querySelector('[data-option-value]');
        if (label) label.textContent = opts[i] || '';
      });
      markAvailability(opts);
      errorEl.textContent = '';

      if (!v) {
        addBtn.disabled = true;
        addBtn.textContent = S.unavailable;
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? S.addToBag : S.soldOut;
      if (priceEl) {
        priceEl.innerHTML = esc(formatMoney(v.price)) +
          (v.compare_at_price > v.price ? ' <s>' + esc(formatMoney(v.compare_at_price)) + '</s>' : '');
      }
      showMedia(v);
      if (isMainProduct) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState(null, '', url.toString());
        } catch (err) { /* ignore */ }
      }
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-option] [data-value]');
      if (opt) {
        opt.closest('[role="radiogroup"]').querySelectorAll('[data-value]').forEach(function (b) {
          b.setAttribute('aria-checked', String(b === opt));
        });
        update();
        return;
      }
      var thumb = e.target.closest('.thumb');
      if (thumb) {
        var mediaId = +thumb.dataset.mediaId;
        var match = product.variants.filter(function (v) { return v.featured_media && v.featured_media.id === mediaId; })[0];
        if (match && groups.length) {
          match.options.forEach(function (val, i) {
            if (!groups[i]) return;
            groups[i].querySelectorAll('[data-value]').forEach(function (b) { b.setAttribute('aria-checked', String(b.dataset.value === val)); });
          });
          update();
        } else {
          selectThumb(thumb);
        }
        return;
      }
      if (e.target.closest('[data-qty-dec]')) qtyInput.value = Math.max(1, (+qtyInput.value || 1) - 1);
      if (e.target.closest('[data-qty-inc]')) qtyInput.value = Math.min(99, (+qtyInput.value || 1) + 1);
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addBtn.disabled = true;
      errorEl.textContent = '';
      fetch(RT.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(handle)
        .then(function () { qtyInput.value = 1; afterAdd(); })
        .catch(function (err) { errorEl.textContent = err.message; })
        .then(function () { addBtn.disabled = false; });
    });

    if (groups.length) markAvailability(selectedOptions());
  }

  /* ---------- Collection sorting ---------- */
  function initSort() {
    document.querySelectorAll('[data-sort]').forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initDrawer();
    initHeader();
    initCards();
    initSort();
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
  });

  // Re-run product logic when a section reloads in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-product-section]').forEach(initProduct);
  });
})();
